@if (teamData) {
  <div>
    <a
      (click)="manageTeam($event)"
      class="mc-team-nav-link"
      [ngClass]="{'mc-team-nav-link_active': isTeamPage}"
      [attr.tabindex]="isSidenavOpened ? '0' : '-1'"
    >
      <div class="mc-team-nav-link-img-wrapper">
        @if (teamData.teamMembers.teamImageUrl) {
          <img [src]="teamData.teamMembers.teamImageUrl" alt="{{ teamData.name }} logo" />
        } @else {
          <div class="mc-team-nav-link-img-wrapper__short-team-name">{{ teamShortName }}</div>
        }
      </div>
      <div class="mc-team-nav-link__text">
        <div class="mc-team-nav-link__team-data">
          <p class="mc-team-nav-link__team-name">{{ teamData.name }}</p>
          @if (teamData.teamMembersCount) {
            <p class="mc-team-nav-link__member-count">
              {{ teamData.teamMembersCount > 1 ? teamData.teamMembersCount + ' team members' : ' 1 team member' }}
            </p>
          } @else {
            <p>No team members</p>
          }
        </div>
        @if (loading) {
          <mc-progress-spinner class="loading-spinner"></mc-progress-spinner>
        } @else {
          <mat-icon class="mc-team-nav-link__icon" svgIcon="triangle_right" aria-hidden="true"></mat-icon>
        }
      </div>
    </a>
  </div>
}
